// extracted by mini-css-extract-plugin
export default {"tooltip":"vU-z","arrow":"wU-z"};